import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { providePrimeNG } from 'primeng/config';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { provideMarkdown } from 'ngx-markdown';

import {
  BrowserCacheLocation,
  InteractionType,
  PublicClientApplication,
} from '@azure/msal-browser';
import {
  MsalModule,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';

import { environment } from '../environments/environment';

import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { httpErrorInterceptor } from './core/interceptors/http-error.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import CRMEnterprisePreset from '../CRMEnterprisePreset';

export const pca = new PublicClientApplication({
  auth: {
    clientId: environment.msalConfig.auth.clientId,
    authority: environment.msalConfig.auth.authority,
    redirectUri: environment.msalConfig.auth.redirectUri,
    postLogoutRedirectUri: environment.msalConfig.auth.postLogoutRedirectUri,
    knownAuthorities: environment.msalConfig.auth.knownAuthorities,
    navigateToLoginRequestUrl: true,
  },
  cache: { cacheLocation: BrowserCacheLocation.SessionStorage },
  system: {
    allowPlatformBroker: false,
  },
});
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: { scopes: [...environment.apiConfig.scopes] },
    loginFailedRoute: '/auth/login',
  };
}
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),

    provideHttpClient(
      withInterceptors([
        authInterceptor,
        loadingInterceptor,
        httpErrorInterceptor,
      ])
    ),

    importProvidersFrom(
      MsalModule.forRoot(pca, MSALGuardConfigFactory(), {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map<string, string[]>(),
      })
    ),
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },

    MsalService,
    MsalGuard,
    MsalBroadcastService,

    providePrimeNG({
      ripple: true,
      theme: {
        preset: CRMEnterprisePreset as any,
        options: {
          darkModeSelector: 'none',
          prefix: 'p',
          cssLayer: { name: 'primeng', order: 'app-styles primeng' },
        },
      },
    }),
    MessageService,
    ConfirmationService,
    DialogService,
    provideMarkdown(),
  ],
};
